export default __webpack_public_path__ + "static/media/setting.c2d5f247.svg";